// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image-space1-ekzR0 {
	margin-bottom: 6px !important;
}

.Image-space2-DcDYN {
	margin-bottom: 12px !important;
}

.Image-space3-qgoZr {
	margin-bottom: 18px !important;
}

.Image-space4-AO2a7 {
	margin-bottom: 24px !important;
}

.Image-space5-WArLj {
	margin-bottom: 30px !important;
}

.Image-space6-yxYe5 {
	margin-bottom: 36px !important;
}

.Image-space7-XnNc_ {
	margin-bottom: 42px !important;
}

.Image-spaceTop8-rVMMl {
	margin-bottom: 48px !important;
}

.Image-spaceTop1-N2_Ip {
	margin-top: 6px !important;
}

.Image-spaceTop2-ChvwJ {
	margin-top: 12px !important;
}

.Image-spaceTop3-OyPiK {
	margin-top: 18px !important;
}

.Image-spaceTop4-m3kvZ {
	margin-top: 24px !important;
}

.Image-spaceTop5-R2Ppq {
	margin-top: 30px !important;
}

.Image-spaceTop6-XoLB0 {
	margin-top: 36px !important;
}

.Image-spaceTop7-zcwlG {
	margin-top: 42px !important;
}

.Image-spaceTop8-rVMMl {
	margin-top: 48px !important;
}

.Image-noMargin-tyhCL {
	margin: 0px !important;
}

.Image-padding1-COCNq {
	padding-bottom: 6px !important;
}

.Image-padding2-gQoGY {
	padding-bottom: 12px !important;
}

.Image-padding3-ryjNo {
	padding-bottom: 18px !important;
}

.Image-padding4-qOcJN {
	padding-bottom: 24px !important;
}

.Image-padding5-jRv81 {
	padding-bottom: 30px !important;
}

.Image-padding6-NmF6V {
	padding-bottom: 36px !important;
}

.Image-padding7-estPy {
	padding-bottom: 42px !important;
}

.Image-paddingTop1-QDxvU {
	padding-top: 6px !important;
}

.Image-paddingTop2-yqCxA {
	padding-top: 12px !important;
}

.Image-paddingTop3-jgxQD {
	padding-top: 18px !important;
}

.Image-paddingTop4-N0esx {
	padding-top: 24px !important;
}

.Image-paddingTop5-HPfX7 {
	padding-top: 30px !important;
}

.Image-paddingTop6-IVVgg {
	padding-top: 36px !important;
}

.Image-paddingTop7-fP89j {
	padding-top: 42px !important;
}

.Image-noPadding-cb271 {
	padding: 0px !important;
}

.Image-textBold-tMAzX {
	font-weight: 500 !important;
}

.Image-textBolder-Hpm_I {
	font-weight: 700 !important;
}

.Image-textNormal-hAhbv {
	font-weight: normal !important;
}

.Image-spaceBottom20-nuqhZ {
	margin-bottom: 20px;
}

.Image-spaceBottom10-_Ibwt {
	margin-bottom: 10px;
}

.Image-marginNone-olrIF {
	margin: 0;
}

.Image-spaceBottom15-jYekq {
	margin-bottom: 15px;
}

.Image-marginTopNone-CP15C {
	margin-top: 0;
}

.Image-spaceTop11-z118s {
	margin-top: 11px;
}

.Image-spaceTop21-YeK4N {
	margin-top: 21px;
}

.Image-spaceTop20-TabsX {
	margin-top: 20px;
}

.Image-spaceTop10-MoFHq {
	margin-top: 10px;
}

/*New Design Text Colors */

.Image-textDarkBlue-ez9KC {
	color: rgb(20, 39, 94) !important;
}

.Image-textLightBlue-gRWJh {
	color: rgb(57, 87, 106) !important;
}

.Image-textLightSandleGreen-uu9b1 {
	color: rgb(76, 86, 41) !important;
}

.Image-textLightBrown-NK3CT {
	color: rgb(115, 79, 33) !important;
}

.Image-textMediumMaroon-pLXsH {
	color: rgb(87, 37, 51) !important;
}

.Image-textBrown-iZir9 {
	color: rgb(160, 47, 24) !important;
}

.Image-textMaroon-AsLIa {
	color: rgb(155, 49, 67) !important;
}

.Image-textDarkBrown-WkjMa {
	color: rgb(83, 18, 16) !important;
}

.Image-textMediumBrown-h5eFP {
	color: rgb(142, 28, 10) !important;
}

.Image-textSkyBlue-JxNj0 {
	color: rgb(37, 117, 141) !important;
}

.Image-textGray-p6YRT {
	color: rgb(77, 65, 51) !important;
}

.Image-commonHeaderAdmin-YuEqF {
	position: fixed !important;
}

.Image-adminLayout-jYwQJ {
	padding-top: 64px !important;
}

.Image-box-uUMak h2 {
	font-size: 21px;
	font-weight: 600;
}

.Image-exportLink-wLELs {
	margin-bottom: -29px;
}

.Image-blockCenter-GzzCj {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Image-panelHeader-HMQGb {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Image-currencyselect-XBfo7 {
	width: 100%;
	margin-right: 0px;
}

.Image-panelHeader-HMQGb {
	overflow: hidden;
	position: relative;
}

.Image-mar0-WPhkx {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Image-blockCenter-GzzCj {
		padding: 0px;
	}

	.Image-panelHeader-HMQGb {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Image-sideAdminPageWrapper-CHVAq {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Image-panelHeader-HMQGb {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Image-table-sWZ6H {
	display: table;
}

.Image-tableRow-yGDEi {
	display: table-row;
}

.Image-tableCell-ulQbb {
	display: table-cell;
	float: none;
}

.Image-formGroup-snwCV {
	margin-bottom: 6px;
}

.Image-select-LISNR {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Image-noMargin-tyhCL {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Image-exportLink-wLELs {
	padding-top: 10px;
	padding-right: 10px;
}

.Image-labelTextNew-k4nXN {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-displayInline-_8Tyx {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Image-btnUPdate-qJUgT {
	display: inline-block;
}

.Image-btnModalDelete-C6ixq {
	display: inline-block;
	margin-left: 15px;
}

.Image-radioBtn-v31IA {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Image-backgroundImg-n_DoI {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Image-btnUPdate-qJUgT {
		display: block;
		margin-bottom: 12px;
	}

	.Image-btnModalDelete-C6ixq {
		display: block;
		margin-left: 0px;
	}

	.Image-btnWidth-td5BA {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Image-bannerImageBg-oX3Gk {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Image-bannerDelete-DsAvC {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Image-modalRoot-sSAMF {
	padding: 32px;
}

.Image-modalBorderBottom-wWKSP {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Image-logInModalBody-vVObv {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Image-exportSection-JGXza {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Image-exportSectionGridSub-sp1gQ {
	grid-template-columns: 50% 49% !important;
}

.Image-exportText-iVvBM {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Image-exportLinkImg-dC4Vm {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Image-vtrMiddle-Nd7ko {
	vertical-align: middle;
}

.Image-exportImg-ulp0N {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Image-profileViewlabel-Q20Oa {
	display: inline-block;
	width: 38%
}

.Image-profileViewMainContent-cgGDU {
	display: inline-block;
	width: 62%;
}

.Image-profileViewMain-bQ8nM {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Image-profileViewInner-sgum3 {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Image-profileImageSection-GFW0Y {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Image-lastviewInner-IVWaJ {
	padding: 10px;
}

.Image-whyHostHoriLine-lH3mo {
	margin: 30px 0;
}

.Image-tableGrid-h3qY5 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Image-headingContent-EW8YT {
	font-size: 18px;
	font-weight: 500;
}

.Image-refundTextColor-j6cat {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Image-dividerLine-iq6Pa {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Image-smallContent-v34yH {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Image-sideAdminPageWrapper-CHVAq {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Image-sideAdminPageWrapper-CHVAq {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Image-exportSection-JGXza {
		grid-template-columns: 100%;
	}

	.Image-exportSectionGridSub-sp1gQ {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Image-profileViewlabel-Q20Oa {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Image-profileViewMainContent-cgGDU {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Image-ChangeToUpperCase-A8ng0 {
	text-transform: uppercase
}

.Image-noBorder-M4KCO {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Image-siteAdminHeading-DYPyJ {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-siteAdminSubHeading-LPfPq {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-adminFormDivider-pL8m7 {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Image-space1-ekzR0`,
	"space2": `Image-space2-DcDYN`,
	"space3": `Image-space3-qgoZr`,
	"space4": `Image-space4-AO2a7`,
	"space5": `Image-space5-WArLj`,
	"space6": `Image-space6-yxYe5`,
	"space7": `Image-space7-XnNc_`,
	"spaceTop8": `Image-spaceTop8-rVMMl`,
	"spaceTop1": `Image-spaceTop1-N2_Ip`,
	"spaceTop2": `Image-spaceTop2-ChvwJ`,
	"spaceTop3": `Image-spaceTop3-OyPiK`,
	"spaceTop4": `Image-spaceTop4-m3kvZ`,
	"spaceTop5": `Image-spaceTop5-R2Ppq`,
	"spaceTop6": `Image-spaceTop6-XoLB0`,
	"spaceTop7": `Image-spaceTop7-zcwlG`,
	"noMargin": `Image-noMargin-tyhCL`,
	"padding1": `Image-padding1-COCNq`,
	"padding2": `Image-padding2-gQoGY`,
	"padding3": `Image-padding3-ryjNo`,
	"padding4": `Image-padding4-qOcJN`,
	"padding5": `Image-padding5-jRv81`,
	"padding6": `Image-padding6-NmF6V`,
	"padding7": `Image-padding7-estPy`,
	"paddingTop1": `Image-paddingTop1-QDxvU`,
	"paddingTop2": `Image-paddingTop2-yqCxA`,
	"paddingTop3": `Image-paddingTop3-jgxQD`,
	"paddingTop4": `Image-paddingTop4-N0esx`,
	"paddingTop5": `Image-paddingTop5-HPfX7`,
	"paddingTop6": `Image-paddingTop6-IVVgg`,
	"paddingTop7": `Image-paddingTop7-fP89j`,
	"noPadding": `Image-noPadding-cb271`,
	"textBold": `Image-textBold-tMAzX`,
	"textBolder": `Image-textBolder-Hpm_I`,
	"textNormal": `Image-textNormal-hAhbv`,
	"spaceBottom20": `Image-spaceBottom20-nuqhZ`,
	"spaceBottom10": `Image-spaceBottom10-_Ibwt`,
	"marginNone": `Image-marginNone-olrIF`,
	"spaceBottom15": `Image-spaceBottom15-jYekq`,
	"marginTopNone": `Image-marginTopNone-CP15C`,
	"spaceTop11": `Image-spaceTop11-z118s`,
	"spaceTop21": `Image-spaceTop21-YeK4N`,
	"spaceTop20": `Image-spaceTop20-TabsX`,
	"spaceTop10": `Image-spaceTop10-MoFHq`,
	"textDarkBlue": `Image-textDarkBlue-ez9KC`,
	"textLightBlue": `Image-textLightBlue-gRWJh`,
	"textLightSandleGreen": `Image-textLightSandleGreen-uu9b1`,
	"textLightBrown": `Image-textLightBrown-NK3CT`,
	"textMediumMaroon": `Image-textMediumMaroon-pLXsH`,
	"textBrown": `Image-textBrown-iZir9`,
	"textMaroon": `Image-textMaroon-AsLIa`,
	"textDarkBrown": `Image-textDarkBrown-WkjMa`,
	"textMediumBrown": `Image-textMediumBrown-h5eFP`,
	"textSkyBlue": `Image-textSkyBlue-JxNj0`,
	"textGray": `Image-textGray-p6YRT`,
	"commonHeaderAdmin": `Image-commonHeaderAdmin-YuEqF`,
	"adminLayout": `Image-adminLayout-jYwQJ`,
	"box": `Image-box-uUMak`,
	"exportLink": `Image-exportLink-wLELs`,
	"blockCenter": `Image-blockCenter-GzzCj`,
	"panelHeader": `Image-panelHeader-HMQGb`,
	"currencyselect": `Image-currencyselect-XBfo7`,
	"mar0": `Image-mar0-WPhkx`,
	"sideAdminPageWrapper": `Image-sideAdminPageWrapper-CHVAq`,
	"table": `Image-table-sWZ6H`,
	"tableRow": `Image-tableRow-yGDEi`,
	"tableCell": `Image-tableCell-ulQbb`,
	"formGroup": `Image-formGroup-snwCV`,
	"select": `Image-select-LISNR`,
	"labelTextNew": `Image-labelTextNew-k4nXN`,
	"displayInline": `Image-displayInline-_8Tyx`,
	"btnUPdate": `Image-btnUPdate-qJUgT`,
	"btnModalDelete": `Image-btnModalDelete-C6ixq`,
	"radioBtn": `Image-radioBtn-v31IA`,
	"backgroundImg": `Image-backgroundImg-n_DoI`,
	"btnWidth": `Image-btnWidth-td5BA`,
	"bannerImageBg": `Image-bannerImageBg-oX3Gk`,
	"bannerDelete": `Image-bannerDelete-DsAvC`,
	"modalRoot": `Image-modalRoot-sSAMF`,
	"modalBorderBottom": `Image-modalBorderBottom-wWKSP`,
	"logInModalBody": `Image-logInModalBody-vVObv`,
	"exportSection": `Image-exportSection-JGXza`,
	"exportSectionGridSub": `Image-exportSectionGridSub-sp1gQ`,
	"exportText": `Image-exportText-iVvBM`,
	"exportLinkImg": `Image-exportLinkImg-dC4Vm`,
	"vtrMiddle": `Image-vtrMiddle-Nd7ko`,
	"exportImg": `Image-exportImg-ulp0N`,
	"profileViewlabel": `Image-profileViewlabel-Q20Oa`,
	"profileViewMainContent": `Image-profileViewMainContent-cgGDU`,
	"profileViewMain": `Image-profileViewMain-bQ8nM`,
	"profileViewInner": `Image-profileViewInner-sgum3`,
	"profileImageSection": `Image-profileImageSection-GFW0Y`,
	"lastviewInner": `Image-lastviewInner-IVWaJ`,
	"whyHostHoriLine": `Image-whyHostHoriLine-lH3mo`,
	"tableGrid": `Image-tableGrid-h3qY5`,
	"headingContent": `Image-headingContent-EW8YT`,
	"refundTextColor": `Image-refundTextColor-j6cat`,
	"dividerLine": `Image-dividerLine-iq6Pa`,
	"smallContent": `Image-smallContent-v34yH`,
	"ChangeToUpperCase": `Image-ChangeToUpperCase-A8ng0`,
	"noBorder": `Image-noBorder-M4KCO`,
	"siteAdminHeading": `Image-siteAdminHeading-DYPyJ`,
	"siteAdminSubHeading": `Image-siteAdminSubHeading-LPfPq`,
	"adminFormDivider": `Image-adminFormDivider-pL8m7`
};
module.exports = ___CSS_LOADER_EXPORT___;
